import React, { useEffect, useState } from "react";
import banner from "../../../assets/banner.png";
import "./style.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BannerService from "../../../services/BannerService";

const Banner = () => {
	const [pdf, setPdf] = useState("");
	const { t } = useTranslation();

	useEffect(() => {
		new BannerService()?.getList().then((res) => {
			if (res?.status === 200 && res?.data?.data?.length > 0) {
				let info = res?.data?.data[0]?.catalog;
				setPdf(info);
			}
		});
	}, []);

	return (
		<div className="container mt-5">
			<div className="banner">
				<div className="row">
					<div className="col-md-6 col-12">
						<span className="sub-title">{t("Send Request Design")}</span>
						<p className="title">{t("Great Designs Await!")}</p>
						<p className="numbers">200 {t("Designs")}</p>
						<p className="description">
							{t(
								"Explore the latest opportunities and submit your price offer today."
							)}
						</p>
						<a
							href={pdf}
							target="_blank"
							download
							className="download-pdf mt-3"
							rel="noreferrer">
							{t("Download Pdf")}
						</a>
					</div>
					<div className="col-md-6 col-12">
						<img src={banner} alt="banner" className="w-75 mb-4" />
						<img src={banner} alt="banner" className="w-100" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Banner;
